import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow'; 
import TableCell from '@mui/material/TableCell';
import Radio, { RadioProps } from '@mui/material/Radio';
import Autocomplete from '@mui/material/Autocomplete';
import FormLabel from '@mui/material/FormLabel';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/system';
let strCust=[{title:'',year:'0'}];
const useStyles = styled(theme => ({
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
export default class BusinessSetting extends Component {
constructor(props) {
    super(props);
	this.state={logredirect:false,submitbtn:"Save",BusiCustomerData:[],
	ledgerdata:[],ledger:'',selectedvendorexchange:[],ledgerarrauto:[],leid:'',vendbilid:'',ledgerarray:[],
	BusiVendorData:[], cusTextValues: ['', '', '', ''],VeTextValues: ['', '', '', ''],
	rowindex:'',Productpricingarr:[],GroupMasterData:[],GroupServiceData:[],gmtye:'1',Expenseledgerarray:[],Expenseledgerarrauto:[],Otherreciptledgerarrauto:[],otherpaymentsledgerarrauto:[],
	bankledgerarrauto:[],
	}
	 this.onTagsLedgerexchange = this.onTagsLedgerexchange.bind(this);
      }
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
}
componentWillMount() {
	document.title = "Isifol Account - Business Setting";
if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			this.GetCustomerSetting();
	this.GetGroupMasterSetting();
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
		   let strname="Business Setting";
	 this.props.parentdasCallback(
            strname+"~"
        ); 
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=18')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
   	this.GetCustomerSetting();
	this.GetGroupMasterSetting();
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
GetCustomerSetting() {
  let strsettings = [];
  axios
    .get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=1&bs_cmp_id='+localStorage.getItem('ISIcmpid'))
    .then(resp => {
      if (resp.data.length > 0) {
        resp.data.map((row, i) => {
          const items = {
            bs_id: row.bs_id,
            bs_title: row.bs_title,
            bs_value:row.bs_value ? row.bs_value.split(',') : '', 
            bs_page: row.bs_page,
            ledgerarray: row.ledgercode && row.aledger
           ? { title: row.ledgercode + " - " + row.aledger, year: row.aledgerid }
          : { title: '', year: '' },
		 };
          strsettings.push(items);
        });
        const initialcusTextValues = strsettings.map((item) =>
          item.bs_value 
        );
        this.setState({
          BusiCustomerData: strsettings,
          cusTextValues: initialcusTextValues[1], 
          VeTextValues: initialcusTextValues[6], 
        });
      } else {
        this.setState({BusiCustomerData: [], cusTextValues: [] ,VeTextValues:[]});
      }
    });
}
  handleSubmit= (event) => {
    let optionsVal=this.state.BusiCustomerData;
	 this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();
	let optionValues="";
    let sep2="";
	  optionsVal.forEach(eachval => {
		 optionValues=optionValues+sep2+eachval.bs_id+"~"+eachval.bs_value;
		 sep2="`"
	   });
	let groupmasterValues="";
	let optionsGroupVal="";
	optionsGroupVal=this.state.GroupMasterData;
		let optionisdeledValues="";
        let sep3=""; 
	  optionsGroupVal.forEach(eachval => 
	  {
		 if(eachval.gm_isdeleted=== "1" )
		    {
				optionisdeledValues=optionisdeledValues+sep3+eachval.gm_id;
			 sep3=","
		    }
		 else if(eachval.gm_name!== "" )
		    	{
				groupmasterValues=groupmasterValues+sep2+eachval.gm_name+"~"+eachval.gm_inuse+"~"+eachval.gm_code+"~"+eachval.gm_type+"~0~"+eachval.gm_id;
						 sep2="`"
			 }
	  });
	  let groupSeriveValues="";
	let optionsGroupServiceVal="";
	optionsGroupServiceVal=this.state.GroupServiceData;
		  optionsGroupServiceVal.forEach(eachval => 
	  {
		 if(eachval.gm_isdeleted=== "1" )
		    {
				optionisdeledValues=optionisdeledValues+sep3+eachval.gm_id;
			 sep3=","
		    }
		 else if(eachval.gm_name!== "" )
		    	{
				groupSeriveValues=groupSeriveValues+sep2+eachval.gm_name+"~"+eachval.gm_inuse+"~"+eachval.gm_code+"~"+eachval.gm_type+"~0~"+eachval.gm_id;
						 sep2="`"
			 }
	  });
	  groupmasterValues=groupmasterValues+groupSeriveValues
	 formData.append('action','update')
	 formData.append('business',optionValues)
	 formData.append('bs_page',1)
     formData.append('bs_cmp_id',localStorage.getItem("ISIcmpid"))
     formData.append('userid',localStorage.getItem("ISIuserid"))
	 formData.append('groupmaster',groupmasterValues)
	formData.append('deletegm_id',optionisdeledValues)
	 axios.post(localStorage.getItem("ISIurl")+"ajaxbusinesssetting.php", formData, {
        }).then(res => {
			this.setState({btndisabled:false,submitbtn:"Save"})
this.GetCustomerSetting();
this.GetGroupMasterSetting() ;
   });    
  };
HandleCustomer= (id, rowsd) => (event) => {
  const value = event.target.value; 
  const updatedArray = [...this.state.BusiCustomerData]; 
  updatedArray[rowsd].bs_value = value; 
  this.setState({ BusiCustomerData: updatedArray }, () => {
  });
};
onloadLedgerBind=(event)=>{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=ledgerautoextender&le_displayname='+event.target.value+'&le_issales=1'+'&le_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => { 
  this.setState({ledgerarray:resp.data},()=>{
	   var rowsArray = this.state.ledgerarray;
	 rowsArray.map((row, i) => {
		 const items = {
         title:row.le_code+ "-" + row.title  ,
         year:row.year,
        };
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		 });
		  this.setState({ledgerarrauto:strCust})
  });
  });
}
onTagsLedgerexchange = (id) => (event, values) => {
  if (values) {
    this.setState(
      {
			leid:values.year, 
			selectedvendorexchange:values, 
      },
      () => {
			  const updatedArray = [...this.state.BusiCustomerData];
			  updatedArray[id].ledgerarray = values;
			  updatedArray[id].bs_value = this.state.leid; 
			  this.setState({BusiCustomerData: updatedArray });
      }
    );
  }
};
onloadLedgerBindForVendor =(event)=>{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=ledgerautoextender&le_displayname='+event.target.value+'&le_isexpenses=1'+'&le_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => { 
  this.setState({ledgerarray:resp.data},()=>{
	  console.log(this.state.ledgerarray);
	   var rowsArray = this.state.ledgerarray;
	 rowsArray.map((row, i) => {
		 const items = {
         title:row.le_code+ "-" + row.title  ,
         year:row.year,
        };
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		 });
		  this.setState({Expenseledgerarrauto:strCust})
  });
  });
}
onTagsLedgerexchangeForVendor = (id) => (event, values) => {
  if (values) {
    this.setState(
      {
			leid:values.year, 
			selectedvendorexchange1:values, 
      },
      () => {
			  const updatedArray = [...this.state.BusiCustomerData];
			  updatedArray[id].ledgerarray = values;
			  updatedArray[id].bs_value = this.state.leid; 
			  this.setState({BusiCustomerData: updatedArray });
      }
    );
  }
};
onloadLedgerBindForOtherReceipt =(event)=>{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=ledgerautoextender&le_displayname='+event.target.value+'&le_otherreciepts=1'+'&le_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => { 
  this.setState({ledgerarray:resp.data},()=>{
	  console.log(this.state.ledgerarray);
	   var rowsArray = this.state.ledgerarray;
	 rowsArray.map((row, i) => {
		 const items = {
         title:row.le_code+ "-" + row.title  ,
         year:row.year,
        };
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		 });
		  this.setState({Otherreciptledgerarrauto:strCust})
  });
  });
}
onTagsLedgerexchangeForOtherReceipt = (id) => (event, values) => {
  if (values) {
    this.setState(
      {
			leid:values.year, 
			selectedvendorexchange2:values, 
      },
      () => {
			  const updatedArray = [...this.state.BusiCustomerData];
			  updatedArray[id].ledgerarray = values;
			  updatedArray[id].bs_value = this.state.leid; 
			  this.setState({BusiCustomerData: updatedArray });
      }
    );
  }
};
onloadLedgerBindForOtherPayments =(event)=>{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=ledgerautoextender&le_displayname='+event.target.value+'&le_otherpayments=1'+'&le_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => { 
  this.setState({ledgerarray:resp.data},()=>{
	  console.log(this.state.ledgerarray);
	   var rowsArray = this.state.ledgerarray;
	 rowsArray.map((row, i) => {
		 const items = {
         title:row.le_code+ "-" + row.title  ,
         year:row.year,
        };
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		 });
		  this.setState({otherpaymentsledgerarrauto:strCust})
  });
  });
}
onTagsLedgerexchangeForOtherpayments = (id) => (event, values) => {
  if (values) {
    this.setState(
      {
			leid:values.year, 
			selectedvendorexchange3:values, 
      },
      () => {
			  const updatedArray = [...this.state.BusiCustomerData];
			  updatedArray[id].ledgerarray = values;
			  updatedArray[id].bs_value = this.state.leid; 
			  this.setState({BusiCustomerData: updatedArray });
      }
    );
  }
};
onloadLedgerBindForBank =(event)=>{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=ledgerautoextender&le_displayname='+event.target.value+'&le_isbank=1'+'&le_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => { 
  this.setState({ledgerarray:resp.data},()=>{
	  console.log(this.state.ledgerarray);
	   var rowsArray = this.state.ledgerarray;
	 rowsArray.map((row, i) => {
		 const items = {
         title:row.le_code+ "-" + row.title  ,
         year:row.year,
        };
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		 });
		  this.setState({bankledgerarrauto:strCust})
  });
  });
}
onTagsLedgerexchangeForBank = (id) => (event, values) => {
  if (values) {
    this.setState(
      {
			leid:values.year, 
			selectedvendorexchange3:values, 
      },
      () => {
			  const updatedArray = [...this.state.BusiCustomerData];
			  updatedArray[id].ledgerarray = values;
			  updatedArray[id].bs_value = this.state.leid; 
			  this.setState({BusiCustomerData: updatedArray });
      }
    );
  }
};
myChangeHandlerCustomer = (id, index) => (event) => {
  const { value } = event.target;
  let updatedcusTextValues = [...this.state.cusTextValues];
  updatedcusTextValues[index] = value;
  const updatedData = this.state.BusiCustomerData.map((item) => {
    if (item.bs_id === id) {
      item.bs_value = updatedcusTextValues.join(",");
    }
    return item;
  });
  this.setState({
    cusTextValues: updatedcusTextValues,
    BusiCustomerData: updatedData,
  });
};
myChangeHandlerVendor = (id, index) => (event) => {
  const { value } = event.target;
  let updatedcusTextValues = [...this.state.VeTextValues];
  updatedcusTextValues[index] = value;
  const updatedData = this.state.BusiCustomerData.map((item) => {
    if (item.bs_id === id) {
      item.bs_value = updatedcusTextValues.join(",");
    }
    return item;
  });
  this.setState({
    VeTextValues: updatedcusTextValues,
    BusiCustomerData: updatedData,
  },()=>{
	  console.log('BusiCustomerData',this.state.BusiCustomerData)
  });
};
GetGroupDatForServiceRate() {
  axios
    .get(localStorage.getItem("ISIurl") + "ajaxgroupmaster.php?action=getall&gm_type=4&gm_cmp_id="+localStorage.getItem("ISIcmpid"))
    .then((resp) => {
      if (resp.data.length > 0) {
        this.setState(
          {
            GroupServiceData: resp.data,
          },
          () => {
            this.setState({
              GroupServiceData: this.state.GroupServiceData.concat([
                {
                  gm_name: "",
                  gm_inuse: "1",
                  gm_code: "",
                 gm_type:"4",
                  gm_isdeleted: "0",
                  gm_id: "0",
                },
              ]),
            });
          }
        );
      } else {
      }
    })
}
GetGroupMasterSetting() {
  axios
    .get(localStorage.getItem("ISIurl") + "ajaxgroupmaster.php?action=getall&gm_type=1&gm_cmp_id="+localStorage.getItem("ISIcmpid"))
    .then((resp) => {
      if (resp.data.length > 0) {
        this.setState(
          {
            GroupMasterData: resp.data,
          },
          () => {
            this.setState({
              GroupMasterData: this.state.GroupMasterData.concat([
                {
                  gm_name: "",
                  gm_inuse: "1",
                  gm_code: "",
                  gm_type:"1",
                  gm_isdeleted: "0",
                  gm_id: "0",
                },
              ]),
            });
          }
        );
      } 
	  else{
	    this.setState({GroupMasterData:[]});
	   }
    })
    	   this.GetGroupDatForServiceRate();
}
myChangeHandlerPV = (index, gmid) => (event) => {
  const { name, value, checked } = event.target;
  let updatedArray = [...this.state.GroupMasterData];
  if (name === "gm_name") {
    updatedArray[index].gm_name = value;
  }
  if (name === "gm_inuse") {
    updatedArray[index].gm_inuse = checked ? "1" : "0";
  }
  this.setState({ GroupMasterData:updatedArray });
};
myChangeHandlerService = (index, gmid) => (event) => {
  const { name, value, checked } = event.target;
  let updatedArray = [...this.state.GroupServiceData];
  if (name === "gm_name") {
    updatedArray[index].gm_name = value;
  }
  if (name === "gm_inuse") {
    updatedArray[index].gm_inuse = checked ? "1" : "0";
  }
 this.setState({ GroupServiceData:updatedArray });
};
GrowpMasterServiceOnBlurevent = (index, gmid) => (event) => {
	 let updatedArray = [...this.state.GroupServiceData];
	if( updatedArray[index].gm_id==="0" ){
	const newRow = {
      gm_name: "",
                  gm_inuse: "1",
                  gm_code: "",
               gm_type:"4",
                  gm_isdeleted: "0",
                  gm_id: "0",
    };
    updatedArray = updatedArray.concat(newRow);
	}
	 this.setState({ GroupServiceData:updatedArray });
}
GrowpMasterOnBlurevent = (index, gmid) => (event) => {
	 let updatedArray = [...this.state.GroupMasterData];
	if( updatedArray[index].gm_id==="0" ){
	const newRow = {
      gm_name: "",
                  gm_inuse: "1",
                  gm_code: "",
               gm_type:"1",
                  gm_isdeleted: "0",
                  gm_id: "0",
    };
    updatedArray = updatedArray.concat(newRow);
	}
	 this.setState({ GroupMasterData:updatedArray });
}
onRowdelete(gmid, rowindex) {
  let confirmDelete = window.confirm("Are you sure to delete?");
  if (confirmDelete) {
    const updatedArray = [...this.state.GroupMasterData];
    if (updatedArray[rowindex].gm_id !== "") {
      updatedArray[rowindex].gm_isdeleted = "1";
    } else {
      updatedArray[rowindex].gm_isdeleted = "0";
    }
    this.setState({GroupMasterData: updatedArray }, () => {
    });
  } else {
    alert("You cannot delete this row.");
    return false;
  }
}
onRowServicedelete(gmid, rowindex) {
  let confirmDelete = window.confirm("Are you sure to delete?");
  if (confirmDelete) {
    const updatedArray = [...this.state.GroupServiceData];
    if (updatedArray[rowindex].gm_id !== "") {
      updatedArray[rowindex].gm_isdeleted = "1";
    } else {
      updatedArray[rowindex].gm_isdeleted = "0";
    }
    this.setState({GroupServiceData:updatedArray }, () => {
    });
  } else {
    alert("You cannot delete this row.");
    return false;
  }
}
HandlerInvoiceDue = (id, index) => (event) => {
  const { value } = event.target;
  let updatedData = [...this.state.BusiCustomerData];
  let currentVal = String(updatedData[index].bs_value || "");
  let parts = currentVal.split(",");
  let secondVal = value === "1" ? (parts[1] && parts[1].trim() !== "" ? parts[1] : "0") : "0";
  updatedData[index].bs_value = [value, secondVal].join(",");
  this.setState({ BusiCustomerData: updatedData });
};
HandlerInvoiceDueText = (id, index) => (event) => {
  const { value } = event.target;
  let updatedData = [...this.state.BusiCustomerData];
  let currentVal = String(updatedData[index].bs_value || "");
  let parts = currentVal.split(",");
  let radioVal = parts[0] || "";
  const numericValue = value.replace(/\D/g, ""); 
  updatedData[index].bs_value = [radioVal, numericValue].join(",");
  this.setState({ BusiCustomerData: updatedData });
};
HandlerPaymentTremText = (id, index) => (event) => {
  const { value } = event.target; 
  let updatedData = [...this.state.BusiCustomerData];
  let currentVal = String(updatedData[index].bs_value || "");
  let parts = currentVal.split(",");
  let radioVal = parts[0] || "";
  updatedData[index].bs_value = [radioVal, value].join(",");
  this.setState({ BusiCustomerData: updatedData });
};
HandlerPaymentTerm = (id, index) => (event) => {
  const { value } = event.target; 
  let updatedData = [...this.state.BusiCustomerData];
  let currentVal = String(updatedData[index].bs_value || "");
  let parts = currentVal.split(",");
  let secondVal = "";
  if (value === "1") {
    secondVal = parts[1] && parts[1].trim() !== "" ? parts[1] : "0";
  } else {
    secondVal = "0";
  }
  updatedData[index].bs_value = [value, secondVal].join(",");
  this.setState({ BusiCustomerData: updatedData });
};
  render() { 
  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  return (
		<React.Fragment>
    <p><Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
<div className="formmain">
  <div className="businesssetting">
    <div className="leftpagetitle">
      <h5>Customer</h5>
      <p>
        Set defaults for your sales to customers. You can override these for
        individual sales later if you like.
      </p>
    </div>
    <div className="pagecontentright">
      <Table>
        {this.state.BusiCustomerData.map((item, index) => (
          <React.Fragment key={index}>
{item.bs_id === "1" && (
  <TableRow>
    <TableCell sx={{ verticalAlign: "middle", width: { xs: "200px", md: "400px" } }}>
      <h6>{item.bs_title}*</h6>
    </TableCell>
    <TableCell>
      <FormControl className="preference">
        <RadioGroup
          value={String(item.bs_value || "").split(",")[0]}
          onChange={this.HandlerInvoiceDue(item.bs_id, index)}
        >
          <FormControlLabel
            value="1"
            control={<Radio />}
            label="Number of days after invoice date"
            sx={{ "& .MuiSvgIcon-root": { fontSize: 18, color: "green" } }}
          />
          {(String(item.bs_value || "").split(",")[0] === "1" || 
            parseFloat(String(item.bs_value || "").split(",")[1] || 0) > 0) && (
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              value={String(item.bs_value || "").split(",")[1] || "0"}
              onChange={this.HandlerInvoiceDueText(item.bs_id, index)}
              className="txtbox"
            />
          )}
          <FormControlLabel
            value="2"
            control={<Radio />}
            label="End of the month following invoice date (net monthly)"
            sx={{ "& .MuiSvgIcon-root": { fontSize: 18, color: "green" } }}
          />
          <FormControlLabel
            value="3"
            control={<Radio />}
            label="Same as invoice date"
            sx={{ "& .MuiSvgIcon-root": { fontSize: 18, color: "green" } }}
          />
        </RadioGroup>
      </FormControl>
    </TableCell>
  </TableRow>
)}
            {item.bs_id === "2" && (
              <TableRow>
                <TableCell 
				  sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}</h6>
                  <p>
                    Show outstanding (or unallocated) customer balances in a
                    column per aging period or month on Aged Debtors report or
                    customers statements.
                  </p>
                </TableCell>
                <TableCell>
                  <div className="agebymonth">
                    <FormControl className="preference">
                      <p>From :&nbsp;
				<TextField
					className="smalltextfeild"
					value={this.state.cusTextValues[0]}
					id="txtvalue1"
					name="txtvalue1"
					onChange={this.myChangeHandlerCustomer(item.bs_id, 0)} 
				  />
				  <TextField
					className="smalltextfeild"
					value={this.state.cusTextValues[1]}
					id="txtvalue2"
					name="txtvalue2"
					onChange={this.myChangeHandlerCustomer(item.bs_id, 1)} 
				  />
				  <TextField
					className="smalltextfeild"
					value={this.state.cusTextValues[2]}
					id="txtvalue3"
					name="txtvalue3"
					onChange={this.myChangeHandlerCustomer(item.bs_id, 2)} 
				  />
				  <TextField
					className="smalltextfeild"
					value={this.state.cusTextValues[3]}
					id="txtvalue4"
					name="txtvalue4"
					onChange={this.myChangeHandlerCustomer(item.bs_id, 3)} 
				  />
				</p>
                    </FormControl>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {item.bs_id === "3" && (
              <TableRow>
                <TableCell
				  sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.ledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchange(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBind}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
            {item.bs_id === "4" && (
              <TableRow>
                <TableCell
				  sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.ledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchange(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBind}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
            {item.bs_id === "5" && (
              <TableRow>
                <TableCell
				  sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.ledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchange(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBind}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </Table>
    </div>
    <div className="clear"></div>
  </div>
 <div className="businesssetting">
    <div className="leftpagetitle">
      <h5>Vendors</h5>
      <p>
        Set defaults for your sales to customers. You can override these for
        individual sales later if you like.
      </p>
    </div>
    <div className="pagecontentright">
      <Table>
        {this.state.BusiCustomerData.map((item, index) => (
          <React.Fragment key={index}>
{item.bs_id === "6" && (
  <TableRow>
    <TableCell sx={{ verticalAlign: "middle", width: { xs: "200px", md: "400px" } }}>
      <h6>{item.bs_title}*</h6>
    </TableCell>
    <TableCell>
      <FormControl className="preference">
        <RadioGroup
          value={String(item.bs_value || "").split(",")[0]}   
          onChange={this.HandlerPaymentTerm(item.bs_id, index)}
          sx={{ "& .MuiSvgIcon-root": { fontSize: 18, color: "green" } }}
        >
          <FormControlLabel
            value="1"
            control={<Radio />}
            label="Number of days after invoice date"
          />
        {(String(item.bs_value || "").split(",")[0] === "1" || 
  parseFloat(String(item.bs_value || "").split(",")[1] || 0) > 0) && (
  <TextField
    variant="outlined"
    margin="normal"
    fullWidth
    type="number"
    inputProps={{ min: 0 }}
    value={String(item.bs_value || "").split(",")[1] || "0"}
    onChange={this.HandlerPaymentTremText(item.bs_id, index)}
    className="txtbox"
  />
)}
          <FormControlLabel
            value="2"
            control={<Radio />}
            label="End of the month following invoice date (net monthly)"
          />
          <FormControlLabel
            value="3"
            control={<Radio />}
            label="Same as invoice date"
          />
        </RadioGroup>
      </FormControl>
    </TableCell>
  </TableRow>
)}
            {item.bs_id === "7" && (
              <TableRow>
                <TableCell
               sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                  <p>
                    Show outstanding (or unallocated) customer balances in a
                    column per aging period or month on Aged Debtors report or
                    customers statements.
                  </p>
                </TableCell>
                <TableCell>
                  <div className="agebymonth">
                    <FormControl className="preference">
                      <p>From :&nbsp;
				<TextField
					className="smalltextfeild"
					value={this.state.VeTextValues[0]}
					id="txtvalue1"
					name="txtvalue1"
					onChange={this.myChangeHandlerVendor(item.bs_id, 0)} 
				  />
				  <TextField
					className="smalltextfeild"
					value={this.state.VeTextValues[1]}
					id="txtvalue2"
					name="txtvalue2"
					onChange={this.myChangeHandlerVendor(item.bs_id, 1)} 
				  />
				  <TextField
					className="smalltextfeild"
					value={this.state.VeTextValues[2]}
					id="txtvalue3"
					name="txtvalue3"
					onChange={this.myChangeHandlerVendor(item.bs_id, 2)} 
				  />
				  <TextField
					className="smalltextfeild"
					value={this.state.VeTextValues[3]}
					id="txtvalue4"
					name="txtvalue4"
					onChange={this.myChangeHandlerVendor(item.bs_id, 3)} 
				  />
				</p>
                    </FormControl>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {item.bs_id === "8" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.Expenseledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForVendor(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForVendor}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
            {item.bs_id === "9" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.Expenseledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchange(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onTagsLedgerexchangeForVendor}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </Table>
    </div>
    <div className="clear"></div>
  </div>
 <div className="businesssetting">
    <div className="leftpagetitle">
      <h5>Payments & Receipts</h5>
      <p>
        Set how you’d like to handle payment transactions to vendors, and receipt transactions from customers.
      </p>
    </div>
    <div className="pagecontentright">
      <Table>
        {this.state.BusiCustomerData.map((item, index) => (
          <React.Fragment key={index}>
            {item.bs_id === "10" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.Otherreciptledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForOtherReceipt(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForOtherReceipt}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
			 {item.bs_id === "11" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.otherpaymentsledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForOtherpayments(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForOtherPayments}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
		    {item.bs_id === "12" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.Otherreciptledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForOtherReceipt(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForOtherReceipt}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
		   {item.bs_id === "13" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.otherpaymentsledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForOtherpayments(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForOtherPayments}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
		   {item.bs_id === "14" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.bankledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForBank(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForBank}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
		   {item.bs_id === "15" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.bankledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForBank(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForBank}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
		   {item.bs_id === "16" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.otherpaymentsledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForOtherpayments(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForOtherPayments}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
		   {item.bs_id === "17" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.Otherreciptledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForOtherReceipt(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForOtherReceipt}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </Table>
    </div>
    <div className="clear"></div>
  </div>
<div className="businesssetting">
    <div className="leftpagetitle">
      <h5>Products & Services</h5>
      <p>
      Set the prices or rates you’d like to use when you sell products or services to customers.
      </p>
    </div>
        <div className="pagecontentright">
      <h5>Product Prices</h5>
       <Table>
         <tr>
       <td>
    <Table className="busigroupmaster" cellspacing="1" cellpadding="1" >
      <thead>
        <tr>
<th style={{ fontSize:'12px',padding: "10px", border: "1px solid black", backgroundColor: "#ccd6db" }}></th>
          <th style={{ textAlign:"left",fontSize:'12px',padding: "12px", border: "1px solid black", backgroundColor: "#ccd6db" }}>Price Name*(last entry cannot be deleted/inactive)</th>
          <th style={{ fontSize:'12px',padding: "12px", border: "1px solid black", backgroundColor: "#ccd6db" }}>In Use</th>
        </tr>
      </thead>
  <tbody>
  {this.state.GroupMasterData.length > 0 &&
    this.state.GroupMasterData.map((rows, i) => {
      return (
        <tr key={rows.gm_id}>  
		{rows.gm_isdeleted=== "0" && (
		<React.Fragment>
	  <td style={{ border: "1px solid black" }}>
     {rows.gm_name !== "" ? (rows.gm_inuse === "0" ? (
        <DeleteIcon 
         onClick={() => this.onRowdelete(rows.gm_id, i)} />
        ) : (
         <DeleteIcon 
        onClick={() => {}} 
        style={{ pointerEvents: "none", opacity: 0.5 }} 
           />
         )
         ) : null}
         </td>
          <td style={{ border: "1px solid black" }}>
            <TextField
              name="gm_name"
             onChange={this.myChangeHandlerPV(i,rows.gm_id)} 
			 onBlur={this.GrowpMasterOnBlurevent(i,rows.gm_id)}
              fullWidth
              value={rows.gm_name}  
              ref={this.usernameInput}
              inputProps={{ tabIndex: '1', maxLength: 150 }}
              className="txtbox"
              InputLabelProps={{ shrink: true }}
            />
          </td>
        <td style={{ border: "1px solid black" }}>
 <Checkbox
  name="gm_inuse"
  value={rows.gm_inuse}
  sx={{
    '&.Mui-checked svg': {
      fill: 'black', 
    },
  }}
  onChange={this.myChangeHandlerPV(i, rows.gm_id)}
  checked={rows.gm_inuse === "1"} 
/>
</td>
		  </React.Fragment>
		)}
        </tr>
      );
    })}
</tbody>
    </Table>
</td>
       </tr>
    </Table>	
    </div>
    <div className="clear"></div>
  </div>
 <div className="businesssetting">
    <div className="leftpagetitle">
    </div>
    <div className="pagecontentdiv">
	<h5>Default Non-stock Ledger Accounts</h5>
	 <Table>
        {this.state.BusiCustomerData.map((item, index) => (
          <React.Fragment key={index}>
			 {item.bs_id === "18" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.ledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchange(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBind}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
			 {item.bs_id === "19" && (
              <TableRow>
                <TableCell
				 sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
				>
                  <h6>{item.bs_title}*</h6>
                </TableCell>
                <TableCell>
                  <Autocomplete
                    options={this.state.Expenseledgerarrauto}
                    value={item.ledgerarray}
                    inputValue={item.aledgerid}
                    onChange={this.onTagsLedgerexchangeForVendor(index)}
                    getOptionLabel={(option) => option.title || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a Ledger"
                        className="txtbox"
                        onChange={this.onloadLedgerBindForVendor}
                        variant="outlined"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </Table>
    </div>
    <div className="clear"></div>
  </div>
<div className="businesssetting">
  <div className="leftpagetitle"></div>
  <div className="pagecontentdiv">
    <h5>Default Stock Ledger Accounts</h5>
    <Table>
      {this.state.BusiCustomerData.map((item, index) => (
        <React.Fragment key={index}>
          {item.bs_id === "20" && (
            <TableRow>
              <TableCell
                sx={{
                  verticalAlign: "middle",
                  width: { xs: "200px", md: "400px" },
                }}
              >
                <h6>{item.bs_title}*</h6>
              </TableCell>
              <TableCell>
                <Autocomplete
                  options={this.state.ledgerarrauto}
                  value={item.ledgerarray}
                  inputValue={item.aledgerid}
                  onChange={this.onTagsLedgerexchange(index)}
                  getOptionLabel={(option) => option.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search for a Ledger"
                      className="txtbox"
                      onChange={this.onloadLedgerBind}
                      variant="outlined"
                    />
                  )}
                />
              </TableCell>
            </TableRow>
          )}
     {item.bs_id === "21" && (
		  <TableRow>
			<TableCell>{item.bs_title}</TableCell>
			<TableCell>
			  <FormControl>
				<RadioGroup
				  row
				  value={item.bs_value}
				  onChange={this.HandleCustomer(item.bs_id, index)}
				  sx={{
					"& .MuiSvgIcon-root": {
					  fontSize: 18,
					  color: "green",
					},
				  }}
				>
				  <FormControlLabel
					disabled
					value="disabled"
					control={<Radio />}
					label="Metric"
				  />
				  <FormControlLabel
					disabled
					value="disabled"
					control={<Radio />}
					label="Imperial (UK)"
				  />
				  <FormControlLabel
					value="3"
					control={<Radio />}
					label="Imperial (US)"
				  />
				</RadioGroup>
			  </FormControl>
			</TableCell>
		  </TableRow>
)}
		   {item.bs_id === "22" && (
            <TableRow>
              <TableCell>{item.bs_title}</TableCell>
              <TableCell>
				<Select
				 native
				 variant="outlined" className="txtbox"
				  margin="normal"
				  onChange={this.HandleCustomer(item.bs_id, index)}
				  id="bs_value"
				 value={item.bs_value}
				 name="bs_value"
					inputProps={{tabIndex: "4"}}
				>
	    <option value={0}>Select Unit</option>
	    <option value={1}>Ounce(oz)</option>
	    <option value={2}>Pound(lb)</option>	
	     <option value={3}>on(t)</option>	
        </Select>
              </TableCell>
            </TableRow>
          )}
        </React.Fragment>
      ))}
    </Table>
  </div>
  <div className="clear"></div>
</div>
<div className="businesssetting">
  <div className="leftpagetitle"></div>
  <div className="pagecontentdiv">
    <Table className="busigroupmaster" cellspacing="1" cellpadding="1" >
      <thead>
        <tr>
<th style={{ fontSize:'12px',padding: "10px", border: "1px solid black", backgroundColor: "#ccd6db" }}></th>
          <th style={{ textAlign:"left",fontSize:'12px',padding: "12px", border: "1px solid black", backgroundColor: "#ccd6db" }}>Price Name*(last entry cannot be deleted/inactive)</th>
          <th style={{ fontSize:'12px',padding: "12px", border: "1px solid black", backgroundColor: "#ccd6db" }}>In Use</th>
        </tr>
      </thead>
  <tbody>
  {this.state.GroupServiceData.length > 0 &&
    this.state.GroupServiceData.map((rows, i) => {
      return (
        <tr key={rows.gm_id}>  
		{rows.gm_isdeleted=== "0" && (
		<React.Fragment>
	  <td style={{ border: "1px solid black" }}>
     {rows.gm_name !== "" ? (
      rows.gm_inuse === "0" ? (
        <DeleteIcon 
         onClick={() => this.onRowServicedelete(rows.gm_id, i)} 
       />
        ) : (
         <DeleteIcon 
        onClick={() => {}} 
        style={{ pointerEvents: "none", opacity: 0.5 }} 
           />
         )
         ) : null}
         </td>
          <td style={{ border: "1px solid black" }}>
            <TextField
              name="gm_name"
             onChange={this.myChangeHandlerService(i,rows.gm_id)} 
			 onBlur={this.GrowpMasterServiceOnBlurevent(i,rows.gm_id)}
              fullWidth
              value={rows.gm_name}  
              ref={this.usernameInput}
              inputProps={{ tabIndex: '1', maxLength: 150 }}
              className="txtbox"
              InputLabelProps={{ shrink: true }}
            />
          </td>
        <td style={{ border: "1px solid black" }}>
 <Checkbox
  name="gm_inuse"
  value={rows.gm_inuse}
  sx={{
    '&.Mui-checked svg': {
      fill: 'black', 
    },
  }}
  onChange={this.myChangeHandlerService(i, rows.gm_id)}
  checked={rows.gm_inuse === "1"} 
/>
</td>
		  </React.Fragment>
		)}
        </tr>
      );
    })}
</tbody>
    </Table>
  </div>
  <div className="clear"></div>
</div>
<div className="businesssetting">
  <div className="leftpagetitle"></div>
  <div className="pagecontentdiv">
    <h5>Default Service Ledger Accounts</h5>
    <Table>
      {this.state.BusiCustomerData.map((item, index) => (
        <React.Fragment key={index}>
          {item.bs_id === "23" && (
            <TableRow>
              <TableCell
                sx={{
                  verticalAlign: "middle",
                  width: { xs: "200px", md: "400px" },
                }}
              >
                <h6>{item.bs_title}*</h6>
              </TableCell>
              <TableCell>
                <Autocomplete
                  options={this.state.ledgerarrauto}
                  value={item.ledgerarray}
                  inputValue={item.aledgerid}
                  onChange={this.onTagsLedgerexchange(index)}
                  getOptionLabel={(option) => option.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search for a Ledger"
                      className="txtbox"
                      onChange={this.onloadLedgerBind}
                      variant="outlined"
                    />
                  )}
                />
              </TableCell>
            </TableRow>
          )}
		  {item.bs_id === "24" && (
            <TableRow>
              <TableCell
                sx={{
                  verticalAlign: "middle",
                  width: { xs: "200px", md: "400px" },
                }}
              >
                <h6>{item.bs_title}*</h6>
              </TableCell>
              <TableCell>
                <Autocomplete
                  options={this.state.ledgerarrauto}
                  value={item.ledgerarray}
                  inputValue={item.aledgerid}
                  onChange={this.onTagsLedgerexchange(index)}
                  getOptionLabel={(option) => option.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search for a Ledger"
                      className="txtbox"
                      onChange={this.onloadLedgerBind}
                      variant="outlined"
                    />
                  )}
                />
              </TableCell>
            </TableRow>
          )}
		  {item.bs_id === "25" && (
            <TableRow>
              <TableCell
                sx={{
                  verticalAlign: "middle",
                  width: { xs: "200px", md: "400px" },
                }}
              >
                <h6>{item.bs_title}*</h6>
              </TableCell>
              <TableCell>
				<Select
				 native
				 variant="outlined" className="txtbox"
				  margin="normal"
				  onChange={this.HandleCustomer(item.bs_id, index)}
				  id="bs_value"
				value={item.bs_value}
				 name="bs_value"
					inputProps={{tabIndex: "4"}}
				>
				 <option value={0}></option>
				<option value={1}>Item Description</option>
				<option value={2}>Item Code</option>	
				</Select>
              </TableCell>
            </TableRow>
          )}
        </React.Fragment>
      ))}
    </Table>
  </div>
  <div className="clear"></div>
</div>
 <div className="businesssetting">
    <div className="leftpagetitle">
      <h5>Accounting Settings</h5>
      <p>
       Set how you’d like ledger accounts to be sorted in menus and the Chart of Accounts, and how you’d like to handle negative assets.
      </p>
    </div>
    <div className="pagecontentright">
      <Table>
        {this.state.BusiCustomerData.map((item, index) => (
          <React.Fragment key={index}>
          {item.bs_id === "26" && (
            <TableRow>
              <TableCell
                sx={{
                  verticalAlign: "middle",
                  width: { xs: "200px", md: "400px" },
                }}
              >
                <h6>{item.bs_title}</h6>
              </TableCell>
              <TableCell>
               	<Select
				  native
				  variant="outlined" className="txtbox"
				  margin="normal"
				  onChange={this.HandleCustomer(item.bs_id, index)}
				  id="bs_value"
				  value={item.bs_value}
				  name="bs_value"
				  inputProps={{tabIndex: "4"}}
				>
				<option value={0}>Select Ledger Account</option>
				<option value={1}>Account Number</option>
				<option value={2}>Ledger Name</option>	
				</Select>
              </TableCell>
            </TableRow>
          )}
		  {item.bs_id === "27" && (
            <TableRow>
              <TableCell
                sx={{
                  verticalAlign: "middle",
                  width: { xs: "200px", md: "400px" },
                }}
              >
                <h6>{item.bs_title}</h6>
              </TableCell>
              <TableCell>
               	<Select
				 native
				 variant="outlined" className="txtbox"
				  margin="normal"
				 onChange={this.HandleCustomer(item.bs_id, index)}
				  id="bs_value"
				 value={item.bs_value}
				 name="pr_unit"
					bs_value={{tabIndex: "4"}}
				>
				 <option value={0}></option>
				<option value={1}>As Negative Assets</option>
				<option value={2}>As Liabilities</option>	
				</Select>
              </TableCell>
            </TableRow>
          )}
		  {item.bs_id === "28"   && (
            <TableRow>
              <TableCell
                sx={{
                  verticalAlign: "middle",
                  width: { xs: "200px", md: "400px" },
                }}
              >
                <h6>{item.bs_title}</h6>
              </TableCell>
              <TableCell>
                	<Select
				 native
				 variant="outlined" className="txtbox"
				  margin="normal"
				  onChange={this.HandleCustomer(item.bs_id, index)}
				  id="pr_unit"
				 value={item.bs_value}
				 name="pr_unit"
					inputProps={{tabIndex: "4"}}
				>
				 <option value={0}></option>
				<option value={1}>Separately on Balance sheet</option>
				<option value={2}>Within Calculated Profit/Loss</option>	
				</Select>
              </TableCell>
            </TableRow>
          )}
          </React.Fragment>
        ))}
      </Table>
    </div>
    <div className="clear"></div>
  </div>
</div>
<p className="aligncentr"> 
	 <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   {this.state.submitbtn}
</Button></p>
 </React.Fragment>
  );
  }
}